export const statusCategories = Object.freeze({
  DONE: 'done',
  DRAFT: 'draft',
  HELD: 'held',
  IN_PROGRESS: 'in_progress',
  FAILED: 'failed',
})

export const statusColors = Object.freeze({
  awaiting_delete_validation: '#F39C12',
  done: '#068925',
  draft: '#5E7997',
  held: '#0079C7',
  in_progress: '#F2B21D',
  failed: '#D10027',
})

export const customStatusesColors = Object.freeze([
  '#CC4D00',
  '#4B8505',
  '#078283',
  '#3665D4',
  '#4040B5',
  '#973DCD',
  '#D23774',
])
